import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Button from '../ui/Button';
import authService from '../../services/auth';

const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState('');

  if (!user || user.email_verified) {
    return null;
  }

  const handleResend = async () => {
    setIsResending(true);
    setMessage('');

    try {
      await authService.resendVerificationEmail({ email: user.email });
      setMessage('Verification email sent! Please check your inbox.');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Failed to send verification email');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-yellow-700">
            <strong>Email verification required.</strong> Please verify your email address to access all features. 
            Check your inbox for a verification link.
          </p>
          {message && (
            <p className={`text-sm mt-1 ${
              message.includes('sent') ? 'text-green-700' : 'text-red-700'
            }`}>
              {message}
            </p>
          )}
          <div className="mt-2">
            <Button
              size="sm"
              variant="outline"
              onClick={handleResend}
              isLoading={isResending}
              disabled={isResending}
            >
              {isResending ? 'Sending...' : 'Resend Email'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
